import React from "react";
import { Box, IconButton, Typography } from "@mui/material";
import { useTheme } from "@mui/styles";
import { useEnableColors } from "../../../hooks/useEnableColors";
import { X } from "lucide-react";
import { ComponentType } from "../../../constants";
import { getColorByComponentType } from "../../program-calendar/utils/common";
import { useTemplateSidebar } from "../../../contexts/ComponentTemplateSidebarContext";
import { TEMPLATE_SIDEBAR_HEADING_HEIGHT } from "./SidebarTemplate";

interface ITemplateSidebarTitleProps {
  type: ComponentType;
  onClose?: () => void;
}

const TemplateSidebarTitle = (props: ITemplateSidebarTitleProps) => {
  const { type, onClose } = props;
  const theme = useTheme();
  const enableColors = useEnableColors();
  const { closeSidebar } = useTemplateSidebar();
  const color = getColorByComponentType(type);

  const handleClose = React.useCallback(() => {
    if (onClose) {
      onClose();
    }
    closeSidebar();
  }, [onClose, closeSidebar]);

  return (
    <>
      <Box
        sx={{
          height: TEMPLATE_SIDEBAR_HEADING_HEIGHT,
          position: "sticky",
          top: 0,
          borderTopLeftRadius: 4,
          borderTopRightRadius: 4,
          zIndex: 1,
          display: "flex",
          borderBottom: "1px solid",
          color: theme.palette.common.white,
          borderColor: theme.palette.divider,
          backgroundColor: theme.palette.common.black,

          ...(enableColors && {
            color: theme.palette.common.white,
            borderColor: color,
            backgroundColor: color,
          }),
        }}
      >
        <Typography
          sx={{
            fontWeight: "bold",
            textAlign: "center",
            width: "100%",
            alignContent: "center",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginLeft: "34px",
          }}
        >
          {type}
        </Typography>
        <IconButton onClick={handleClose} color="inherit" size="small">
          <X />
        </IconButton>
      </Box>
    </>
  );
};

export default TemplateSidebarTitle;
